// extracted by mini-css-extract-plugin
module.exports = {"horizontalDivider":"HorizontalDivider_horizontalDivider__1Elf7","darkTheme":"HorizontalDivider_darkTheme__3oT2z","lightTheme":"HorizontalDivider_lightTheme__20SNm"};